import React from 'react'
import ProjectsList from '../../components/tables/ProjectsList';
import RecentAppActivity from '../../components/tables/RecentAppActivity';
import RecentWebsiteActivity from '../../components/tables/RecentWebsiteActivity';
import ManualTimesheet from '../../components/tables/ManualTimesheet';
import MembersProgress from '../../components/tables/MembersProgress';
import DailyTimeChart from '../../components/chart/DailyTimeChart';
import LastWeekChart from '../../components/chart/LastWeekChart';
import { Grid, Box } from '@mui/material';
const AllTabsData = () => {
    return (
        <>
            <Box className='mt-24'>
                <Grid container spacing={2}>
                    <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}>
                        <ProjectsList />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, md: 3, sm: 6, xs: 12 }}>
                        <DailyTimeChart />
                    </Grid>
                    <Grid size={{ xl: 3, lg: 3, md: 3, sm: 6, xs: 12 }}>
                        <LastWeekChart />
                    </Grid>
                </Grid>

                <div className='row mt-24 '>
                    <div className='col-sm-12 col-md-6 mb-24'>
                        <RecentAppActivity />
                    </div>
                    <div className='col-sm-12 col-md-6 mb-24'>
                        <RecentWebsiteActivity />
                    </div>
                </div>
                <div className='row '>
                    <div className='col-sm-12 col-md-6 mb-24'>
                        <ManualTimesheet />
                    </div>
                    <div className='col-sm-12 col-md-6 mb-24'>
                        <MembersProgress />
                    </div>
                    <div className='col-sm-12 col-md-12'>
                        {/* <TimelineChart />  */}
                    </div>
                </div>
            </Box>
        </>
    )
}

export default AllTabsData